import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from './services/auth.service';

import { environment } from '../environments/environment';
import { MsalService } from '@azure/msal-angular';

import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {

  title = 'Crono - Ekstern Admin';
  isIframe = false;

  constructor(private authService: AuthService) { }


  async ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal
    console.log('Environment: ' + environment.msalConfig.auth.authority);
    console.log('IsIframe: ' + this.isIframe);
  }

}
